/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LabelGroup } from "./LabelGroup";
import {
  LabelGroupFromJSON,
  LabelGroupFromJSONTyped,
  LabelGroupToJSON,
  LabelGroupToJSONTyped,
} from "./LabelGroup";

/**
 *
 * @export
 * @interface LabelWithLabelGroup
 */
export interface LabelWithLabelGroup {
  /**
   *
   * @type {string}
   * @memberof LabelWithLabelGroup
   */
  labelId: string;
  /**
   *
   * @type {string}
   * @memberof LabelWithLabelGroup
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof LabelWithLabelGroup
   */
  description?: string | null;
  /**
   *
   * @type {LabelGroup}
   * @memberof LabelWithLabelGroup
   */
  labelGroup: LabelGroup;
}

/**
 * Check if a given object implements the LabelWithLabelGroup interface.
 */
export function instanceOfLabelWithLabelGroup(
  value: object,
): value is LabelWithLabelGroup {
  if (!("labelId" in value) || value["labelId"] === undefined) return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("labelGroup" in value) || value["labelGroup"] === undefined)
    return false;
  return true;
}

export function LabelWithLabelGroupFromJSON(json: any): LabelWithLabelGroup {
  return LabelWithLabelGroupFromJSONTyped(json, false);
}

export function LabelWithLabelGroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LabelWithLabelGroup {
  if (json == null) {
    return json;
  }
  return {
    labelId: json["labelId"],
    title: json["title"],
    description: json["description"] == null ? undefined : json["description"],
    labelGroup: LabelGroupFromJSON(json["labelGroup"]),
  };
}

export function LabelWithLabelGroupToJSON(json: any): LabelWithLabelGroup {
  return LabelWithLabelGroupToJSONTyped(json, false);
}

export function LabelWithLabelGroupToJSONTyped(
  value?: LabelWithLabelGroup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    labelId: value["labelId"],
    title: value["title"],
    description: value["description"],
    labelGroup: LabelGroupToJSON(value["labelGroup"]),
  };
}
